import React, { isValidElement, useEffect } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import { IconButton } from '@mui/material';
import {
  GridRenderCellParams,
  gridDetailPanelExpandedRowsContentCacheSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';

import { useAppState } from '../../../context/AppState';

const CustomDetailPanelToggle = (
  props: Pick<GridRenderCellParams, 'id' | 'value'>
) => {
  const { id, value: isExpanded } = props;
  const apiRef = useGridApiContext();
  const { appState, appDispatch } = useAppState();

  useEffect(() => {
    appDispatch({ type: 'SET_ZOOM', payoad: 'default' });
  }, [appDispatch]);

  // To avoid calling ´getDetailPanelContent` all the time, the following selector
  // gives an object with the detail panel content for each row id.
  const contentCache = useGridSelector(
    apiRef,
    gridDetailPanelExpandedRowsContentCacheSelector
  );

  // If the value is not a valid React element, it means that the row has no detail panel.
  const hasDetail = isValidElement(contentCache[id]);
  return (
    <IconButton
      size='small'
      tabIndex={-1}
      disabled={!hasDetail}
      aria-label={isExpanded ? 'Close' : 'Open'}
    >
      <VisibilityIcon
        sx={{
          width: appState.zoom == 'out' ? 16 : 20,
        }}
        color='primary'
      />
    </IconButton>
  );
};

export default CustomDetailPanelToggle;
